import { Link } from "react-router-dom";
import { KeyRound, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-900 border-t border-slate-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-16 flex flex-col md:flex-row md:items-center justify-between gap-8">
        <div>
          <img src="/logo-acs-noir.webp" alt="ACS Corporate" className="h-8 w-auto brightness-0 invert" data-testid="footer-logo" />
          <p className="mt-3 text-sm text-slate-400">
            Ingénierie financière — Restructuration — M&A
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-8 text-sm text-slate-400">
          <Link to="/mentions-legales" className="hover:text-white transition-colors" data-testid="footer-link-mentions">
            Mentions Légales
          </Link>
          <Link to="/confidentialite" className="hover:text-white transition-colors" data-testid="footer-link-confidentialite">
            Politique de Confidentialité
          </Link>
          <button
            onClick={() => window.dispatchEvent(new Event("acs:open-cookies"))}
            className="hover:text-white transition-colors cursor-pointer"
            data-testid="footer-link-cookies"
          >
            Gestion des Cookies
          </button>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-2 hover:text-white transition-colors"
          >
            <KeyRound className="w-3.5 h-3.5" strokeWidth={1.5} />
            Espace admin
          </Link>
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            data-testid="footer-linkedin"
            className="inline-flex items-center text-slate-400 hover:text-white transition-colors"
          >
            <Linkedin className="w-4 h-4" strokeWidth={1.5} />
          </a>
        </div>
        <p className="text-xs text-slate-500">© 2026 ACS Corporate. Tous droits réservés.</p>
      </div>
    </footer>
  );
}
